import src from "IMAGE";
export default { src, width: 900, height: 600, blurWidth: 0, blurHeight: 0};
